import httpApiApplication from 'app/http/httpApiApplication';

import { type EnrollmentTaxPayerInfo } from '../types';

export const base = '/taxpayerrequest';
export const baseEnrollment = '/taxpayerrequest/EnrollmentRequests';

export const saveTaxypayerRequest = (request: EnrollmentTaxPayerInfo) => {
  return httpApiApplication.post(baseEnrollment, request);
};

export const updateTaxypayerRequest = (id: string, request: EnrollmentTaxPayerInfo) => {
  return httpApiApplication.put(`${baseEnrollment}/${id}`, request);
};
